export const getSearchPath = (
  template: any,
  isUserExpired: any,
  setIsSearchHidden: (val: boolean) => void,
  setIsOpen: (val: boolean) => void,
) => {
  const path = isUserExpired
    ? '/'
    : template.path.includes('{Asset}')
      ? template.path.replace('{Asset}', template.name).replace('asset', 'Asset')
      : template.path.includes('{label}')
        ? template.path.replace('{label}', template.name)
        : template.path.includes('{date}') && template.path.includes('{appId}')
          ? template.path.replace('{appId}', template.appId).replace('{date}', template.date)
          : template.path.includes('{date}')
            ? template.path.replace('{date}', template.date)
            : template.path.replace('{appId}', template.appId);
  setIsSearchHidden(true);
  setIsOpen(false);
  let fxPath = '';
  const base = path?.split('?')[0];
  const params = path?.split('?')[1]?.split('&');

  if (params?.[0].includes('Resolution') && params?.[1].includes('Reservoir')) {
    fxPath = `${base}?${params[1]}&${params[0]}`;
  }

  return fxPath || path.replace(/\+/g, '%20');
};
